import { gsap } from 'gsap'

// The one place GSAP plugins and defaults get registered, so every
// component animates with the same configured instance.
export { gsap }
